import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteCollab } from 'redux/colabsSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonClose from 'utils/buttons/ButtonClose';
import ButtonDelete from 'utils/buttons/ButtonDelete';

const DeleteModal = ({ user, setShow, switchNewUser, setSwitchNewUser }) => {
  const dispatch = useDispatch();

  const handleClose = () => setShow(false);

  const handleDelete = async () => {
    const response = await dispatch(deleteCollab(user.id));
    if (response < 400) {
      setSwitchNewUser(!switchNewUser);
      handleClose();
    }
  };

  return (
    <>
      <Modal
        keyboard={true}
        show={true}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <FontAwesomeIcon
            icon="fa-trash-can"
            title="Eliminar"
            size="1x"
            style={{ marginRight: 8, color: '#e63757' }}
          />

          <Modal.Title>Eliminar usuario</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            El usuario{' '}
            <b>
              {user.firstName} {user.lastName}
            </b>{' '}
            perderá su cuenta y ya no podrá recuperarla.
            <br />
            <br />
            ¿Está seguro de confirmar esta acción?
          </div>
          <ModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleClose}
              variant="secondary"
            />

            <ButtonDelete text="Eliminar" funcion={handleDelete} />
          </ModalButtonsContainer>
        </Modal.Body>
      </Modal>
    </>
  );
};

DeleteModal.propTypes = {
  user: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  switchNewUser: PropTypes.bool.isRequired,
  setSwitchNewUser: PropTypes.func.isRequired
};

export default DeleteModal;
